export const validateSaveForm = (currentCode, { name, code, comment }) => {
    return !!(currentCode ? name && comment : code && name && comment);
};

export const getNameByCodeFromList = (list, code, isHotel) => {
    const configs = _.filter(list, element => element.ContentCode === code);
    if (configs.length <= 1) {
        return _.get(configs[0], 'MetaData.Name', '');
    }
    const hotelOrChainConfig = configs.find(element => {
        return isHotel ? element.level === 'hotel' : element.level === 'chain';
    });

    return _.get(hotelOrChainConfig, 'MetaData.Name', '');
};



// WEBPACK FOOTER //
// ./src/components/modals/editFile/utils.js